import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePlus } from "@fortawesome/pro-regular-svg-icons";

const BulkSkuUploader = ({ onSkusAdded, existingSkus = [] }) => {
  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      const lines = content.split("\n");
      const newSkus = [];

      lines.forEach((line) => {
        // Handle both CSV and TSV formats
        const sku = line.trim().split(/[,\t]/)[0]; // Split by comma or tab, take first column
        if (sku && sku.length > 0) {
          newSkus.push(sku);
        }
      });

      // Add new SKUs to existing ones, avoiding duplicates
      const existingSkusFiltered = existingSkus.filter(
        (sku) => sku.trim() !== ""
      );
      const allSkus = [...existingSkusFiltered, ...newSkus];
      const uniqueSkus = [...new Set(allSkus)];

      onSkusAdded(uniqueSkus);
    };

    reader.readAsText(file);

    // Reset the file input
    event.target.value = "";
  };

  return (
    <>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        accept=".csv,.tsv,.txt"
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />

      <button
        className="btn btn-sm btn-secondary w-100"
        onClick={(e) => {
          e.preventDefault();
          fileInputRef.current.click();
        }}
      >
        <FontAwesomeIcon icon={faFilePlus} className="mr-2" /> Bulk Add SKUs
      </button>
    </>
  );
};

export default BulkSkuUploader;
